/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
// BASE Components
import BASELoading from "../../../../../../../@BASE/core/BASELoading";
// Material-UI Components
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
// Custom Components
import EMentor from "../components/EMentor";
import Instructions from "../components/Instructions";

const NoteCards = (props) => {
  const { data, dir, ins = [], course, comments = [] } = props;
  const tl = `${dir === "rtl" ? "text-18" : "text-14"} ${course?.language?.acronym}`.trim();

  if (!data) {
    return <BASELoading />;
  }

  // filer comments by component_id
  const componentCommentsCount = (component) => {
    return comments.filter(
      (comment) =>
        comment.component === component && comment.internality !== true
    ).length;
  };

  return (
    <div>
      <style>
        {`
          .wysiwyg p {
            margin: 0px;
          }
        `}
      </style>
      
      <Instructions
        ins={ins}
        course={course}
        dir={dir}
        tl={tl}
        componentCommentsCount={componentCommentsCount}
      />

      <Typography className="text-16 font-bold p-16 pb-0">
        Page Content:
      </Typography>

      <Paper elevation={0} variant="outlined" square className="p-16 mx-16">
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Typography className="text-14 font-bold m-0">
                  Contextual Instructions (TL):
                </Typography>
                <Divider className="my-16" />
              </Grid>
              <Grid item xs={12}>
                <Typography
                  className={`${tl} m-0 wysiwyg`}
                  dir={dir}
                  dangerouslySetInnerHTML={{ __html: data.context_tl }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>

      <Paper elevation={0} variant="outlined" square className="p-16 mx-16">
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Typography className="text-14 font-bold m-0">
                  Contextual Instructions (EN):
                </Typography>
                <Divider className="my-16" />
              </Grid>
              <Grid item xs={12}>
                <Typography
                  className="m-0 wysiwyg"
                  dangerouslySetInnerHTML={{ __html: data.context_en }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>

      <Paper elevation={0} variant="outlined" square className="p-16 mx-16">
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Typography className="text-14 font-bold m-0">
                  Prompt:
                </Typography>
                <Divider className="my-16" />
              </Grid>
              <Grid item xs={12}>
                <Typography
                  className={`${tl} m-0 wysiwyg`}
                  dir={dir}
                  dangerouslySetInnerHTML={{ __html: data.prompt }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>

      {data.cards.map((card, index) => (
        <Paper
          elevation={0}
          variant="outlined"
          square
          className="p-16 m-16"
          key={`card-${card.title}-${index}`}
        >
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Typography className="text-14 font-bold m-0">
                Note Card {index + 1}:
              </Typography>
              <Divider className="my-16" />
              <Grid container spacing={2} columns={12}>
                <Grid item xs={12} lg={6}>
                  <Card className="w-full" variant="outlined">
                    <CardContent className="p-16">
                      <Typography className="text-14 font-bold m-0">
                        Title (Front of Card):
                      </Typography>
                      <Divider className="my-16" />
                      <Typography
                        className={`${tl} m-0 wysiwyg`}
                        dir={dir}
                        dangerouslySetInnerHTML={{ __html: card.title }}
                      />
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} lg={6}>
                  <Card className="w-full" variant="outlined">
                    <CardContent className="p-16">
                      <Typography className="text-14 font-bold m-0">
                        Response (Back of Card):
                      </Typography>
                      <Divider className="my-16" />
                      <Typography
                        className={`${tl} m-0 wysiwyg`}
                        dir={dir}
                        dangerouslySetInnerHTML={{ __html: card.response }}
                      />
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      ))}

      {data.eMentor.length !== 0 && (
        <EMentor
          eMentor={data.eMentor}
          tl={tl}
          dir={dir}
          componentCommentsCount={componentCommentsCount}
        />
      )}
    </div>
  );
};

export default NoteCards;
